import { Star, Quote } from "lucide-react";
import { REVIEWS, FAQS } from "../data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative section-padding bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-14">
          <div className="max-w-xl">
            <div className="eyebrow">Avis clients</div>
            <h2 className="font-display uppercase text-white text-4xl md:text-5xl lg:text-6xl mt-4 leading-[0.95] tracking-tight">
              Ils nous ont fait<br/>
              <span className="text-[#7DD923]">confiance</span>
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex">
              {[1,2,3,4,5].map(i => <Star key={i} className="w-5 h-5 fill-[#7DD923] text-[#7DD923]" />)}
            </div>
            <div className="text-white/70 text-sm">
              <span className="text-white font-semibold">4.9/5</span> · 187 avis vérifiés
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {REVIEWS.map((r, i) => (
            <div
              key={r.name}
              data-testid={`testimonial-${i}`}
              className={`glass rounded-2xl p-6 relative ${i % 2 === 0 ? "md:mt-6" : ""}`}
            >
              <Quote className="w-6 h-6 text-[#7DD923] opacity-40" />
              <div className="flex mt-3">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#7DD923] text-[#7DD923]" />
                ))}
              </div>
              <p className="text-white/80 text-sm mt-4 leading-relaxed">{r.text}</p>
              <div className="mt-5 pt-4 border-t border-white/10">
                <div className="text-white font-semibold text-sm">{r.name}</div>
                <div className="text-white/50 text-xs mt-0.5">{r.location} · {r.project}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section data-testid="faq-section" className="relative section-padding bg-[#050505]">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <div className="eyebrow">FAQ</div>
          <h2 className="font-display uppercase text-white text-4xl md:text-5xl lg:text-6xl mt-4 leading-[0.95] tracking-tight">
            Vos questions,<br/>
            <span className="text-[#7DD923]">nos réponses</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10 last:border-none"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-white hover:no-underline hover:text-[#7DD923] font-semibold text-base py-5 [&[data-state=open]]:text-[#7DD923]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
